import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { RouteConstants } from '../../../core/constants/routes';
import { AuthFlowService } from '../../../core/services/auth-wrapper/auth-flow.service';
import { LoadingDotsComponent } from '../../../shared/components/loading-dots/loading-dots.component';
import { BaseSsoRedirectComponent } from '../base-sso-redirect/base-sso-redirect-component';

/**
 * This component is responsible for handling user redirection to either the dashboard if they are authenticated or to the login flow if they are not.
 * It listens to the authentication state and acts accordingly.
 * This can be used as a landing page for SSO from another application.
 */
@Component({
    selector: 'app-sso-redirect',
    templateUrl: './sso-redirect-component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingDotsComponent],
})
export class SsoRedirectComponent extends BaseSsoRedirectComponent {
    constructor(
        protected override readonly auth0Service: AuthService,
        protected override readonly authFlowService: AuthFlowService,
        protected override readonly router: Router,
    ) {
        super(auth0Service, authFlowService, router);
    }

    protected getAuthenticatedRoute(): string {
        return RouteConstants.Dashboard.getRootUrl();
    }

    protected triggerLoginFlow(): void {
        this.authFlowService.login();
    }
}
